export enum TipoContesto {
  Nd = -1,
  Produzione = 0,
  CaricoMerce = 1,
  InvioTerzista = 4,
  RientroTerzista = 2,
  Rettifica = 3,
  Spedizioni = 5,
  Inventario = 6,
  Prelievo = 7
}

export const TIPO_CONTESTO = [
  {value: TipoContesto.Nd, text: 'Tutti', color: 'bg-white-500'},
  {value: TipoContesto.Produzione, text: 'Produzione', color: 'bg-gray-500'},
  {value: TipoContesto.CaricoMerce, text: 'Carico merce fornitori (evasione DDT)', color: 'bg-yellow-300'},
  {value: TipoContesto.InvioTerzista, text: 'Invio a terzista (DDT)', color: 'bg-yellow-500'},
  {value: TipoContesto.RientroTerzista, text: 'Rientro da terzista (evasione DDT)', color: 'bg-violet-800'},
  {value: TipoContesto.Rettifica, text: 'Rettifica magazzino (ERP)', color: 'bg-green-800'},
  {value: TipoContesto.Spedizioni, text: 'Ordine di spedizione', color: 'bg-blue-800'},
  {value: TipoContesto.Inventario, text: 'Inventario', color: 'bg-red-800'},
  {value: TipoContesto.Prelievo, text: 'Ordine di prelievo', color: 'bg-orange-500'}
];
